<template>
    <div>
        <div v-if="user == null">
            <register></register>
        </div>

        <div class="uk-section uk-section-small">
            <div class="uk-container">
                <h2 class="uk-heading-bullet">{{ area }}{{ member }}{{ tag }}</h2>
                <div class="uk-grid-small" uk-grid uk-lightbox>
                    <Photo v-for="photo in photos" v-bind:key="photo.id" v-bind:photo="photo"></Photo>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import carousel from './components/Carousel'
import register from './components/Register'
import upload from './components/Upload'
import qs from 'qs'
import Photo from './components/Photo'

export default {
    name: 'photoBlock',
    components: {
        carousel,
        register,
        upload,
        Photo
    },
    props: {
    },
    data: function () {
        return {
            user: {},
            area: String,
            member: String,
            tag: String,
            photos: {}
        }
    },
    methods: {
        checkUser: function () {
            this.$axios.get(
                this.$config.common.apiPath + '/loginCheck/'
            )
            .then(response => {
                var rtn = response.data
                if (rtn.status === 'OK') {
                    this.user = {
                        tuid: rtn.tuid
                    }
                } else {
                    this.user = null
                }
            })
            .catch(function (error) {
                this.user = null
            })
        },
        getPhotos: function () {
            this.area = this.$route.query.area
            this.member = this.$route.query.member
            this.tag = this.$route.query.tag

            this.$axios.post(
                this.$config.common.apiPath + '/getPhotosByTag/',
                qs.stringify({'area': this.area, 'member': this.member, 'tag': this.tag})
            )
            .then(response => {
                this.photos = response.data
            })
            .catch( function(error){

            })
        }
    },
    mounted () {
        this.checkUser()
        this.getPhotos()
    },
    watch: {
        '$route' (to, from) {
            this.getPhotos()
        }
    }
}
</script>

<style>
</style>
